import React from 'react';
import styles from './MatchSuggestionTitle.module.scss';

interface MatchSuggestionTitleProps {
  title: string;
  type?: string;
}

export const MatchSuggestionTitle: React.FC<MatchSuggestionTitleProps> = ({
  title,
  type = 'default',
}) => {
  return (
    <div className={styles.MatchSuggestionTitle} id={type}>
      <span>{title}</span> {type === 'default' && <button>OK</button>}
    </div>
  );
};
